<template>
  <el-select
    :disabled="country === 'bh'"
    v-if="country"
    :size="size"
    :value="givenState ? givenState : state"
    placeholder="Select State"
    @change="stateChanged"
    style="width: 100%;"
  >
    <el-option
      :key="item.value"
      :value="item.value"
      v-for="item in countryStates" :label="item.text"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'State',
  props: {
    country: { type: String, required: true },
    givenState: { type: String, default: null },
    size: { type: String, default: 'small' },
    isOrgStateInput: { type: Boolean, default: false },
  },
  computed: {
    countryStates() {
      // Organization State field is only allowed US and CA states
      if (this.isOrgStateInput) { return [...this.usStates, ...this.caStates]; }

      switch (this.country) {
        case 'us': return this.usStates;
        case 'ca': return this.caStates;
        case 'mx': return this.mxStates;
        case 'pr': return [{ text: 'Puerto Rico', value: 'pr' }];
        case 'bh': return [{ text: '', value: '' }];
        default: return [{ text: 'N/A', value: '' }];
      }
    },
  },
  watch: {
    country() {
      this.state = null;
    },
  },
  data() {
    return {
      state: null,
      usStates: [
        { text: 'Alabama', value: 'AL' },
        { text: 'Alaska', value: 'AK' },
        { text: 'Arizona', value: 'AZ' },
        { text: 'Arkansas', value: 'AR' },
        { text: 'California', value: 'CA' },
        { text: 'Colorado', value: 'CO' },
        { text: 'Connecticut', value: 'CT' },
        { text: 'Delaware', value: 'DE' },
        { text: 'District of Columbia', value: 'DC' },
        { text: 'Florida', value: 'FL' },
        { text: 'Georgia', value: 'GA' },
        { text: 'Hawaii', value: 'HI' },
        { text: 'Idaho', value: 'ID' },
        { text: 'Illinois', value: 'IL' },
        { text: 'Indiana', value: 'IN' },
        { text: 'Iowa', value: 'IA' },
        { text: 'Kansas', value: 'KS' },
        { text: 'Kentucky', value: 'KY' },
        { text: 'Louisiana', value: 'LA' },
        { text: 'Maine', value: 'ME' },
        { text: 'Maryland', value: 'MD' },
        { text: 'Massachusetts', value: 'MA' },
        { text: 'Michigan', value: 'MI' },
        { text: 'Minnesota', value: 'MN' },
        { text: 'Mississippi', value: 'MS' },
        { text: 'Missouri', value: 'MO' },
        { text: 'Montana', value: 'MT' },
        { text: 'Nebraska', value: 'NE' },
        { text: 'Nevada', value: 'NV' },
        { text: 'New Hampshire', value: 'NH' },
        { text: 'New Jersey', value: 'NJ' },
        { text: 'New Mexico', value: 'NM' },
        { text: 'New York', value: 'NY' },
        { text: 'North Carolina', value: 'NC' },
        { text: 'North Dakota', value: 'ND' },
        { text: 'Ohio', value: 'OH' },
        { text: 'Oklahoma', value: 'OK' },
        { text: 'Oregon', value: 'OR' },
        { text: 'Pennsylvania', value: 'PA' },
        { text: 'Rhode Island', value: 'RI' },
        { text: 'South Carolina', value: 'SC' },
        { text: 'South Dakota', value: 'SD' },
        { text: 'Tennessee', value: 'TN' },
        { text: 'Texas', value: 'TX' },
        { text: 'Utah', value: 'UT' },
        { text: 'Vermont', value: 'VT' },
        { text: 'Virginia', value: 'VA' },
        { text: 'Washington', value: 'WA' },
        { text: 'West Virginia', value: 'WV' },
        { text: 'Wisconsin', value: 'WI' },
        { text: 'Wyoming', value: 'WY' },
      ],
      caStates: [
        { value: 'AB', text: 'Alberta' },
        { value: 'BC', text: 'British Columbia' },
        { value: 'MB', text: 'Manitoba' },
        { value: 'NB', text: 'New Brunswick' },
        { value: 'NF', text: 'Newfoundland' },
        { value: 'NT', text: 'Northwest Territories' },
        { value: 'NS', text: 'Nova Scotia' },
        { value: 'NU', text: 'Nunavut' },
        { value: 'ON', text: 'Ontario' },
        { value: 'PE', text: 'Prince Edward Island' },
        { value: 'PQ', text: 'Quebec' },
        { value: 'SK', text: 'Saskatchewan' },
        { value: 'YT', text: 'Yukon' }
      ],
      mxStates: [
        { text: 'Aguascalientes', value: 'AG' },
        { text: 'Baja California Norte', value: 'BN' },
        { text: 'Baja California Sur', value: 'BS' },
        { text: 'Coahuila', value: 'CH' },
        { text: 'Chihuahua', value: 'CI' },
        { text: 'Colima', value: 'CL' },
        { text: 'Campeche', value: 'CP' },
        { text: 'Chiapas', value: 'CS' },
        { text: 'Districto Federal', value: 'DF' },
        { text: 'Durango', value: 'DG' },
        { text: 'Guerrero', value: 'GE' },
        { text: 'Guanajuato', value: 'GJ' },
        { text: 'Hidalgo', value: 'HD' },
        { text: 'Jalisco', value: 'JA' },
        { text: 'Michoacan', value: 'MC' },
        { text: 'Morelos', value: 'MR' },
        { text: 'Mexico', value: 'MX' },
        { text: 'Nayarit', value: 'NA' },
        { text: 'Nuevo Leon', value: 'NL' },
        { text: 'Oaxaca', value: 'OA' },
        { text: 'Puebla', value: 'PU' },
        { text: 'Queretaro', value: 'QE' },
        { text: 'Quintana Roo', value: 'QI' },
        { text: 'Sinaloa', value: 'SI' },
        { text: 'San Luis Potosi', value: 'SL' },
        { text: 'Sonora', value: 'SO' },
        { text: 'Tamaulipas', value: 'TA' },
        { text: 'Tabasco', value: 'TB' },
        { text: 'Tlaxcala', value: 'TL' },
        { text: 'Veracruz', value: 'VC' },
        { text: 'Yucatan', value: 'YU' },
        { text: 'Zacatecas', value: 'ZA' }
      ],
    };
  },
  methods: {
    stateChanged(st) {
      this.state = st;
      this.$emit('change', st);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sate.vue